// *********************************************************
//
//  言語関連関数
//
// *********************************************************

/**
 * ブラウザの言語を取得
 */
export const browserLanguage = (): string => {
  if (navigator.languages !== undefined && navigator.languages.length > 0) {
    return navigator.languages[0];
  }
  if (navigator.language) {
    return navigator.language;
  }
  return 'en';
};

/**
 * 翻訳用の言語を取得
 */
export const translateLanguage = (): string => {
  const bl = browserLanguage();
  if (bl.match(/^ja/)) {
    return 'ja';
  } else if (bl === 'zh-TW' || bl === 'zh-HK') {
    return 'zh-TW'; // 繁体字
  } else if (bl.match(/^zh/)) {
    return 'zh-CN'; // 簡体字
  } else if (bl.match(/^ko/)) {
    return 'ko';
  } else {
    return 'en';
  }
};

/**
 * 翻訳用言語からブラウザ言語に変換
 *
 * @param tl 翻訳用言語
 * @return ブラウザ言語
 */
export const getBrowserLanguageFromTranslateLanguage = (tl: string) => {
  if (tl === 'ja') {
    return 'ja-JP';
  } else if (tl.match(/^zh/)) {
    return tl;
  } else if (tl === 'ko') {
    return 'ko-KR';
  } else {
    // 英語の場合はブラウザ言語を返す。
    return browserLanguage();
  }
};


